(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-horizontal-banners"] && !window.DesignMode) return;
  try {
    
document.addEventListener('shopify:section:load', function(event) {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`.section-horizontal-banners[data-section-id="${sectionId}"]`);
  if (sectionElement) {
    initHorizontalBannersScroll(sectionElement);
  }
});

document.querySelectorAll('.section-horizontal-banners[data-section-id]').forEach(section => {
  initHorizontalBannersScroll(section);
});

function initHorizontalBannersScroll(sectionNode) {
  const container = sectionNode.querySelector('.horizontal-banners-container');
  const wrapper = sectionNode.querySelector('.horizontal-banners-wrapper');
  const prevButton = sectionNode.querySelector('.scroll-button--prev');
  const nextButton = sectionNode.querySelector('.scroll-button--next');

  if (!container || !wrapper || !prevButton || !nextButton) {
    if(container) container.classList.add('horizontal-banners-container--no-scroll');
    if(prevButton) prevButton.classList.add('hidden');
    if(nextButton) nextButton.classList.add('hidden');
    return;
  }

  const items = wrapper.querySelectorAll('.horizontal-banner-item');

  if (items.length === 0) {
    prevButton.classList.add('hidden');
    nextButton.classList.add('hidden');
    container.classList.add('horizontal-banners-container--no-scroll');
    return;
  }

  let scrollAmount = items[0]?.offsetWidth > 0 ? items[0].offsetWidth + parseInt(getComputedStyle(wrapper).gap || '0') : 350;
  const tolerance = 15;

  function updateButtonVisibility() {
    const currentItems = wrapper.querySelectorAll('.horizontal-banner-item');
      if (currentItems.length > 0 && currentItems[0].offsetWidth > 0) {
        const firstItem = currentItems[0];
        const newScrollAmount = firstItem.offsetWidth + parseInt(getComputedStyle(wrapper).gap || '0');
        if (newScrollAmount > 0) {
           scrollAmount = newScrollAmount;
        }
      } else {
         scrollAmount = 350;
      }

    const currentScroll = wrapper.scrollLeft;
    const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

    if (maxScroll <= tolerance) {
      prevButton.classList.add('hidden');
      prevButton.classList.remove('visible');
      nextButton.classList.add('hidden');
      nextButton.classList.remove('visible');
      container.classList.add('horizontal-banners-container--no-scroll');
      // wrapper.classList.add('align-center-if-no-scroll'); // Liquid側でクラスを付与するためJSからは削除
    } else {
      container.classList.remove('horizontal-banners-container--no-scroll');
      // wrapper.classList.remove('align-center-if-no-scroll'); // Liquid側でクラスを付与するためJSからは削除
      if (currentScroll <= tolerance) {
        prevButton.classList.add('hidden');
        prevButton.classList.remove('visible');
      } else {
        prevButton.classList.add('visible');
        prevButton.classList.remove('hidden');
      }
      if (currentScroll >= maxScroll - tolerance) {
        nextButton.classList.add('hidden');
        nextButton.classList.remove('visible');
      } else {
        nextButton.classList.add('visible');
        nextButton.classList.remove('hidden');
      }
    }
  }

  prevButton.addEventListener('click', () => {
    const currentItems = wrapper.querySelectorAll('.horizontal-banner-item');
    if (currentItems.length > 0 && currentItems[0].offsetWidth > 0) {
      scrollAmount = currentItems[0].offsetWidth + parseInt(getComputedStyle(wrapper).gap || '0');
    } else {
      scrollAmount = 350;
    }
    if (scrollAmount > 0) {
       wrapper.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  });

  nextButton.addEventListener('click', () => {
    const currentItems = wrapper.querySelectorAll('.horizontal-banner-item');
    if (currentItems.length > 0 && currentItems[0].offsetWidth > 0) {
      scrollAmount = currentItems[0].offsetWidth + parseInt(getComputedStyle(wrapper).gap || '0');
    } else {
      scrollAmount = 350;
    }
    if (scrollAmount > 0) {
       wrapper.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  });

  wrapper.addEventListener('scroll', updateButtonVisibility, { passive: true });

  const resizeObserver = new ResizeObserver(updateButtonVisibility);
  resizeObserver.observe(wrapper);
  items.forEach(item => {
     if (item) resizeObserver.observe(item);
  });

  const mutationObserver = new MutationObserver(updateButtonVisibility);
  mutationObserver.observe(wrapper, { childList: true, subtree: false });

  requestAnimationFrame(() => {
     setTimeout(updateButtonVisibility, 250);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:block:select', () => setTimeout(updateButtonVisibility, 100));
    document.addEventListener('shopify:block:deselect', () => setTimeout(updateButtonVisibility, 100));
  }
}

  } catch(e) { console.error(e); }
})();
})();
